/**
 * @generated SignedSource<<a0e34aeef92456020fc859ef398ffce0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarSoldItemsLoading_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsHeader_item">;
  readonly " $fragmentType": "PdpRespSimilarSoldItemsLoading_item";
};
export type PdpRespSimilarSoldItemsLoading_item$key = {
  readonly " $data"?: PdpRespSimilarSoldItemsLoading_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarSoldItemsLoading_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarSoldItemsLoading_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSimilarSoldItemsHeader_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f252ebd4d364a5637b4a71cf79cd409c";

export default node;
